import Image from 'next/image';

export const Schedule = () => {
  const schedules = [
    {
      name: 'WELCOME CHAMPAGNE PARTY',
      image: '/static/images/cabo/champagne-party.png',
      description: `Come make a grand entrance to the kickoff party of your weekend. This is your chance to meet and greet and begin an unforgettable weekend of the best music, vibes and memories. Come dressed in your best fit, grab plenty of champagne, and let’s raise a glass to the trip of the summer and memorable moments ahead.`,
    },
    {
      name: 'BAD & BOUJEE BRUNCH',
      image: '/static/images/cabo/bad-boujee.png',
      description: `Prepare for an extravagant and exclusive brunch experience at our luxurious poolside! Embracing the "Bad and Boujee" vibe, this brunch combines high-class indulgence with the energy of a day party you don’t want to miss. Let us all indulge in sundress season as we enjoy endless mimosas, refreshing cocktails and mix and mingle for the perfect summer time vibe..
      `,
    },
    {
      name: 'SUMMER ISLAND VIBE POOL PARTY!',
      image: '/static/images/cabo/pool-party.png',
      description: `Come join the fun at a pool party featuring an upbeat tropical island vibe. Wear your most colorful and tropical island attire. Our DJ’s will be spinning our favorite artists in a mesmerizing montage of Afrobeats | Soco | Dancehall as you dance and enjoy the summer breeze. Allow the rhythms to take you away to the perfect island escape all while sipping the perfect cocktails!
      `,
    },
    {
      name: 'CABO COMEDY JAM!',
      image: '/static/images/cabo/comedy-jam.png',
      description: `This will be a comedy event to remember. With an all-star lineup of comedic talent, be sure to arrive ready to laugh like never before. Take a front row seat and let your worries go as you enjoy a night packed with good times and funny jokes told by your favorite comedians. Early arrival suggested, doors open at 9pm in the outdoor lobby lounge | drinks and food available.
        `,
    },
    {
      name: 'We 2 Bomb Yacht Party',
      image: '/static/images/cabo/yatch-party.png',
      description: `Ahoy there! Picture this: A sun-soaked weekend in Los Cabo, where the party doesn't stop at the shore. Elevate your stay with our exclusive Yacht Party add-on—an oceanic fiesta that's the epitome of luxury and leisure. Step aboard a glamorous yacht, where the rhythm of the waves syncs with the beats of our top-notch DJ. Imagine sipping on premium cocktails, the sea breeze tousling your hair, and the sun painting the sky with hues of warmth. The party doesn't just stay afloat; it dives into the depths of exhilaration. Dive into the crystal-clear waters if the mood strikes you, or simply bask in the sun on the yacht's deck, surrounded by the breathtaking backdrop of the Cabo coastline. This isn't just a yacht party; it's a symphony of good vibes, great music, and the unparalleled thrill of the open sea. Make your Cabo Memorial Weekend an unforgettable adventure—where the fiesta meets the horizon!
      `,
    },
    {
      name: 'DRUNKEN KARAOKE',
      image: '/static/images/cabo/drunken-karaoke.png',
      description: `Oh, now we're talking! Drunken karaoke with a throwback twist—it's like a musical time machine! So, are we vibing to the smooth R&B jams of the '90s, where love ballads ruled the charts? Or maybe we're unleashing our inner hip-hop heads with the golden era of beats and rhymes from the '80s and '90s? And let's not forget the pop anthems that shaped entire generations! The stage is set, the mic is waiting, and the hits are queued up. As for which decade has the greatest hits? Well, that's a showdown we'll settle on the karaoke battleground. Get ready for a night of vocal acrobatics, nostalgia overload, and a whole lot of fun!

      `,
    },
  ];
  return (
    <>
      <section className="bg-[#2B2922]  text-white py-24">
        {schedules.map((schedule, index) => (
          <section key={index} className={`py-12`}>
            <div className="flex flex-col flex-wrap items-center justify-center w-full">
              <div className="w-full ">
                <div className="flex items-center justify-center gap-1 6 w-full"></div>
              </div>
            </div>
            <div
              className={`flex flex-wrap gap-6 sm:gap-24 px-4 justify-center container mx-auto mt-6 ${
                index % 2 === 0 ? 'flex-row-reverse' : ''
              }`}>
              <Image alt="" width={530} height={375} className="object-contain" src={schedule.image} quality={100} />
              <div className="flex flex-col gap-4">
                <span className="font-solid-grooves text-center text-4xl text-white border-y border-[#FFFF4E] py-4">
                  {schedule.name}
                </span>
                <p className="text-left text-lg max-w-[460px]">{schedule.description}</p>
              </div>
            </div>
          </section>
        ))}
      </section>
    </>
  );
};
